export default `
  mutation startTrial {
    startTrial {
      success
      status
      message
      subscriptionId
    }
  }
`
